<template>
  <main id="content" aria-labelledby="main-title" v-if="page">
    <ElementHero v-if="page?.hero" :content="page?.hero" />
    <template v-if="page?.dynamic">
      <template v-for="(section, index) in page?.dynamic">
        <component 
        :is="getSectionComponent(section.collection)" 
        :sectionIndex="index" 
        :sectionTotal="page.dynamic.length"
        :content="section.item" 
        />
      </template>
    </template>
    <ElementBookDemoCta />
  </main>
</template>

<script setup>
const route = useRoute()
const contentSections = useContentSections()
const { getItems } = useCms()
const fields = useFields()

const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

const { data } = await useAsyncData(
  currentLocale.value+'-page-security',
  () => getItems({
    collection: 'page',
    params: {
      filter: {
        locale: { _contains: currentLocale.value },
        slug: {
          _eq: "security"
        }
      },
      fields
    },
  })
)

const page = data?.value[0]

const seo = computed(() => {
  if (page?.seo) {
    return useSeo(page.seo, route.fullPath)
  }
  return {}
})

useHead(seo)

const getSectionComponent = key => {
  return contentSections[key]
}
</script>